import React from 'react'
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { APP_NAME } from '@/utils/constants'
import egowallMark from '@/assets/images/egowall-mark.png'

/**
 * The Egowall hexagon "e" mark, filled with the spectrum gradient via CSS
 * mask — the PNG is a white silhouette (facet shading baked into its alpha
 * channel), so masking it over the gradient recreates the faceted look in
 * whatever colors `--ds-gradient-spectrum` currently uses. This is the one
 * canonical glyph — other screens should import it rather than re-drawing
 * their own copy.
 */
export const LogoMark = styled(Box, { shouldForwardProp: (prop) => prop !== 'size' })<{ size?: number }>(
  ({ size = 22 }) => ({
    width: size,
    height: size,
    flexShrink: 0,
    background: 'var(--ds-gradient-spectrum, var(--ds-ink))',
    WebkitMaskImage: `url(${egowallMark})`,
    maskImage: `url(${egowallMark})`,
    WebkitMaskSize: 'contain',
    maskSize: 'contain',
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    maskPosition: 'center',
  }),
)

const LogoText = styled(Typography)({
  fontSize: 16.5,
  fontWeight: 750,
  letterSpacing: '-0.03em',
  color: 'var(--ds-ink)',
  lineHeight: 1,
})

interface EgowallLogoProps {
  onClick?: () => void
  hideText?: boolean
}

export function EgowallLogo({ onClick, hideText }: EgowallLogoProps) {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '9px',
        cursor: 'pointer',
        userSelect: 'none',
        flexShrink: 0,
      }}
    >
      <LogoMark />
      {!hideText && <LogoText>{APP_NAME}</LogoText>}
    </Box>
  )
}
